<template>
  <div id="tab-bar">
    <div class="tab-bar-2-wraper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
#tab-bar {
  display: flex;
  background-color: rgba(0, 0, 0, 0.8);

  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  box-shadow: 0 -3px 1px rgba(100, 100, 100, 0.06);

  cursor: pointer; /*移入时光标样式*/
}
.tab-bar-2-wraper {
  /* 这样做是为了兼容移动端或者大屏幕超过1200PX时出问题 */
  display: flex;
  width: 1200px;
  margin: 0 auto;
  /* padding: 0px 10px; */
  box-sizing: border-box;
}
</style>
